import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Input, Select, InputPhone, Textarea } from 'components/fields'
import { LogoUpload } from 'components/misc'
import { permissions } from 'helpers/decorators'
import { ORGANIZATION_HIERARCHY } from '../../../../constants/enums'
import { get } from 'lodash'

@permissions()
class AwardUnitDetail extends Component {
  static propTypes = {
    organizationTypes: PropTypes.array.isRequired,
    permissions: PropTypes.object
  }

  render() {
    const { organizationTypes, permissions: appPermissions } = this.props

    const showNote = appPermissions.isIfSuper || appPermissions.isNaoStaff || appPermissions.isGbt ||
      appPermissions.isOa || appPermissions.isSoa || appPermissions.isGopStaff

    const orgType = get(this.props, 'data.hierarchyLevel.value')

    const showCode = orgType === ORGANIZATION_HIERARCHY.AU.value || ORGANIZATION_HIERARCHY.IAC.value

    const enabledCode = appPermissions.isIfSuper || appPermissions.isNaoStaff || appPermissions.isGbt || appPermissions.isGopStaff

    return (
      <div>
        <div className="row">
          <div className="col-xs-12">
            <LogoUpload {...this.props} />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-12">
            <Input label="Name" intlKey="label.name_organization" name="name" />
          </div>
          {showCode && <div className="col-xs-12">
            <Input label="Code" intlKey="label.code" name="code" disabled={!enabledCode} maxLength={45} />
          </div>}
          <div className="col-xs-6">
            <Select
              label="Type"
              intlKey="label.type"
              name="organizationType.value"
              options={organizationTypes}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <InputPhone
              label="Phone number"
              intlKey="label.phone_number"
              name="phoneNumber"
            />
          </div>
          <div className="col-xs-6">
            <InputPhone label="Fax" intlKey="label.fax" name="faxNumber" />
          </div>
        </div>
        <div className="row">
          <div className="col-xs-6">
            <Input label="Website" intlKey="label.website" name="website" />
          </div>
          <div className="col-xs-6">
            <Input label="Facebook" intlKey="label.facebook" name="facebook" />
          </div>
        </div>
        {showNote &&
          <div className="row">
            <div className="col-xs-12">
              <Textarea
                label="Note"
                intlKey="label.note"
                name="note"
              />
            </div>
          </div>}
      </div>
    )
  }
}

export default AwardUnitDetail
